import {
    IconContainer,
    Icon
} from './Elements'

const Pin = ({ iconSrc }) => {

    return (
        <IconContainer>
            <Icon src={iconSrc} alt="icon location" />
        </IconContainer>
    )
}

export default Pin